import axios from '@/utils/requset'
import { pageResponseHandler,responseHandler } from '@/utils/http'


const api = {
  list: { url: '/client/speakingTasks/getSpeakingTasksList', method: 'get' },
}

export default {
  getMySpeakingTasksList(parameter) {
    return axios({
      url: api.list.url,
      method: api.list.method,
      params: parameter
    }).then(pageResponseHandler)
  },

}